import request from '@/utils/request';
import {
  type CapitalQueryPermissions,
  normalizeCapitalQueryPermissions,
} from './capitalPermissionUtils';

export type { CapitalQueryPermissions } from './capitalPermissionUtils';

export async function fetchCapitalQueryPermissions(): Promise<CapitalQueryPermissions> {
  try {
    const result = await request.get<CapitalQueryPermissions>('/api/capital/query-permissions', {
      silent: true,
    });
    return normalizeCapitalQueryPermissions(result);
  } catch {
    return normalizeCapitalQueryPermissions(null);
  }
}
